import styles from "../styles/pages/main.module.css";
import Nav from "../components/Nav";
import ChannelList from "../components/ChannelList";
import GlobalData from "../components/GlobalData";
import Modal from "../components/Modal";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import OrderService from "../services/order";
import { Order } from "../models/order";
import { observer } from "mobx-react-lite";
import { appStore } from "../stores";
import SubLimitModal from "../components/SubLimitModal";
import BottomModal from "../components/BottomModal";


function Main() {
  const tg = window.Telegram.WebApp;
  const location = useLocation();
  const [salt, setSalt] = useState([...Array(8)].map(() => Math.random().toString(36)[2]).join(""));
  const [openSubWarning, setOpenSubWarning] = useState(false);
  const [orders, setOrders] = useState([] as Order[]);
  const [loading, setLoading] = useState(false);
  const [submitOrderProcess, setSubmitOrderProcess] = useState<number | null>(null);
  const [modalSubLimit, setModalSubLimit] = useState(false);
  const [methodInfo, setMethodInfo] = useState(false);
  const navigate = useNavigate();

  const closeModal = () => {
    tg.HapticFeedback.impactOccurred('light');
    setOpenSubWarning(false);
    localStorage.setItem("SubWarningView", "true");
  };

  const handleRedirect = () => {
    tg.HapticFeedback.impactOccurred("heavy");
    
    if (appStore.chats.length > 0) {
      navigate("/orders", {replace: true});  
    } else {
      navigate("/channels", {replace: true});
    };
  };

  const handleSubscribeChannel = async (order: Order) => {
    tg.HapticFeedback.impactOccurred("light");
    
    if (localStorage.getItem("SubWarningView") !== "true") {
      setOpenSubWarning(true);
      return -1;
    };
    console.log(order.invite_link);
    tg.openTelegramLink(order.invite_link);
  };

  const handleSubscribeButton = async (order: Order) => {
    if (appStore.user.limit <= 0) {
      appStore.addError("Вы исчерпали дневное ограничение подписок");
      setModalSubLimit(true);
      return;
    }
    
    tg.HapticFeedback.impactOccurred("light");
        
    setSubmitOrderProcess(order.id);

    try {
      await OrderService.submit(order.chat_id, order.id);
      setOrders(orders.filter(o => o.chat_id !== order.chat_id));
      appStore.user.balance += order.sub_price;
      appStore.user.limit -= 1;
    } catch (error: any) {
      const errorData = error.response.data as any;
      if (errorData.error.message_ru) {
        appStore.addError(errorData.error.message_ru);
      };
      
      if (errorData.error.code === "SubsLimit") {
        setModalSubLimit(true);  // вибро не надо тк будет от ошибки
        appStore.getUser(); // на всякий случай актуализировать, т.к. фронт не должен был допустить этого исключения
      } else if (errorData.error.code === "OrderNotFound" || errorData.error.code === "AlreadyReceived") {
        // setOrders(orders.filter(o => o.chat_id !== order.chat_id));
        setOrders(orders.filter(o => o.id !== order.id)); // разницы нет, т.к. на один чат можно ток один заказ, но так тестить удобнее (размножать заказы)
      };
    } finally {
      setSubmitOrderProcess(null);
    };
  };
  
  const bottomScroll = async () => {
    if (orders.length === 0)
      return;
    
    const curOrders = orders.filter(el => typeof el.chat_id !== "string");
    const lastOrder = curOrders[curOrders.length - 1];
    
    setLoading(true);
    try {
      const response = await OrderService.get(lastOrder.sub_price, lastOrder.id, salt);
      // Костыль чтобы в коцне подсунутые таски в заказы не размножались (просто привязка к orderid после тасок и если в базе такого заказа нет, то происходит бесконечная подгрузка тасок)
      if (response.data.orders.every(order => typeof order.chat_id === "string") && orders.some(order => typeof order.chat_id === "string"))
        return;

      setOrders(o => [...o, ...response.data.orders]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setOrders([]);

    async function getOrders() {
      setLoading(true);
      try {
        const response = await OrderService.get(null, null, salt);
        setOrders(response.data.orders);
      } finally {
        setLoading(false);
      }
    };

    getOrders();
  }, [location.key]);

  const closeModalSubLimit = () => {
    setModalSubLimit(false);
    tg.HapticFeedback.impactOccurred("light");
  };

  const openMethodInfo = () => {
    tg.HapticFeedback.impactOccurred("light");
    setMethodInfo(true);
  }

  const closeMethodInfo = () => {
    tg.HapticFeedback.impactOccurred("light");
    setMethodInfo(false);
  }

  return (
    <div className={styles.body}>
        {openSubWarning && <Modal cancel={closeModal}>
          <h1>Подписка</h1>
          <div className={styles.sub_modal_desc}>
            <span>После подписки вам будет начислено указанное <span className={styles.sub_modal_green}>вознаграждение</span>. Если вы отпишитесь от канала раньше, чем через неделю, бот снимет с вашего баланса <span className={styles.sub_modal_red}>штраф в размере до двухкратного вознаграждения.</span></span>
            <span>За 24 часа вы можете подписаться только на 15 каналов, поэтому для подписки выбирайте более интересный для вас канал.</span>
          </div>
          <button type="submit" onClick={closeModal}>Понятно</button>
        </Modal>}
        {methodInfo && <BottomModal cancel={closeMethodInfo}>
            <h1>Реклама в списке</h1>
            <div className={styles.method_description}>
              <span><strong>Как работает продвижение:</strong> вы создаёте заказ — ваш проект появляется в списке, а другие пользователи подписываются, чтобы заработать промокоины</span>
              <span><strong>Чем выше оплата за подписку,</strong> тем выше ваше место в списке и тем быстрее получаете подписчиков</span>
              <div>
                <span><strong>Почему это выгодно:</strong></span>
                <ul>
                  <li><strong>Осознанные подписки:</strong> лимит подписок в день не даёт пользователям подписываться массово и без интереса</li>
                  <li><strong>Отписки не засчитываются:</strong> если пользователь отпишется в тот же день — подписка не считается. За отписку в течение недели — штраф</li>
                  <li><strong>Рыночная цена:</strong> цены регулируются рынком — вы платите столько, сколько готовы другие</li>
                </ul>
              </div>
            </div>
            <button onClick={closeMethodInfo}>Понятно</button>
        </BottomModal>}
        {modalSubLimit && <SubLimitModal cancel={closeModalSubLimit} header="Лимит подписок исчерпан"></SubLimitModal>}
        <GlobalData/>
        <ChannelList
          bottomButtons={{"Добавить свой канал": handleRedirect}}
          handleChannelButton={handleSubscribeButton}
          handleChannelClick={handleSubscribeChannel}
          mode="orders"
          list={orders}
          nullMessage={loading && orders.length === 0 ? "Загрузка заказов..." : "Пока что нет заказов для выполнения, вы можете создать свой"}
          scrollBottomCallback={bottomScroll}  
          inline={false}
          processButtons={submitOrderProcess ? [String(submitOrderProcess), ] : []}
          loading={loading && orders.length > 0 ? true : false}
          methodInfoCallback={openMethodInfo}
        />
        <Nav activePage={1}/>
    </div>
  );
}

export default observer(Main);